import React from "react"
import { connect } from "react-redux"
import trans from "trans"

import { ExportsType } from "app/reducers/exports"
import { Progress, css } from "@bdfx/mergado-ui-kit"


export interface Props {
    exportProducts: ExportsType
    close: Function
}

class ModalProductsExportsWrapper extends React.PureComponent<Props> {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <React.Fragment>
            <div>{trans("please_wait_generating_export2")}</div>

            <StyledProgressDiv>
                {!!(this.props.exportProducts.data?.progress && this.props.exportProducts.data?.progress > 0 && this.props.exportProducts.data.progress < 100) &&
                    <Progress
                        showLabel={true}
                        value={this.props.exportProducts.data.progress}
                        color="success"
                        max={100}
                        getValueLabel={(val) => val + ' % '}                        
                    />
                }
            </StyledProgressDiv>

        </React.Fragment>)
    }
}

const StyledProgressDiv = css('div')({
    marginTop: '20px',
    textAlign: 'center',
    '&> div': {
        margin: 'auto',
    }
})


function mapStateToProps(state) {
    return {
        exportProducts: state.exportProducts,
    }
}

export default connect(mapStateToProps, {
})(ModalProductsExportsWrapper)
